import { View } from "@react-pdf/renderer";
import { COLORS } from "./PdfStyles";

/** Horizontal flex row */
export const PdfRow = ({ children, style }) => (
  <View style={[{ flexDirection: "row" }, style]}>{children}</View>
);

/** Flex column that fills available space (flex:1 by default) */
export const PdfCol = ({ children, style, flex = 1 }) => (
  <View style={[{ flex }, style]}>{children}</View>
);

/** Horizontal rule */
export const PdfDivider = ({ style }) => (
  <View
    style={[
      {
        borderBottomWidth: 1,
        borderBottomColor: COLORS.border,
        marginVertical: 4,
      },
      style,
    ]}
  />
);

/** Bordered section container */
export const PdfSection = ({ children, style }) => (
  <View
    style={[
      {
        borderWidth: 1,
        borderColor: COLORS.border,
        backgroundColor: COLORS.bgSection,
        paddingHorizontal: 12,
        paddingVertical: 6,
      },
      style,
    ]}
  >
    {children}
  </View>
);

/** 1pt vertical rule (for two-column dividers inside a bordered section) */
export const PdfVerticalDivider = ({ style }) => (
  <View
    style={[{ width: 1, backgroundColor: COLORS.border, marginHorizontal: 4 }, style]}
  />
);

/** Wrapper that adds bottom margin between sections */
export const PdfSpacer = ({ size = 4, style }) => (
  <View style={[{ marginBottom: size }, style]} />
);
